module.exports = __webpack_public_path__ + "img/page7_blur.1141d52f.png";